export const groups = [
  {
    id: "gatiandi-xiaobandeng",
    rank: 1,
    name: "瓜田里的小板凳",
    category: "娱乐八卦",
    platform: "微信群",
    members: 4860,
    activity: 96,
    rating: 4.9,
    score: 98,
    trend: "up",
    featured: true,
    tags: ["日更", "氛围好", "禁广告"],
    summary:
      "专注娱乐圈动态的日更群，热点发生后两小时内就有人整理时间线，适合想第一时间跟上节奏的瓜友。",
    highlights: ["热点响应快，时间线整理清晰", "群规严格，刷屏与广告零容忍", "每晚固定「今日瓜回顾」总结"],
    joinTip: "入群需回答两道娱乐常识小题，答对即可通过。",
  },
  {
    id: "meiri-yigua-sudi",
    rank: 2,
    name: "每日一瓜速递站",
    category: "娱乐八卦",
    platform: "微信群",
    members: 5120,
    activity: 93,
    rating: 4.8,
    score: 96,
    trend: "flat",
    featured: true,
    tags: ["日更", "新手友好", "话题广"],
    summary:
      "群内每天固定推送三条精选资讯，覆盖综艺、剧集、音乐多个方向，节奏轻松，适合刚接触吃瓜的新朋友。",
    highlights: ["早中晚三次定时推送，不打扰", "配有简洁背景说明，新手也看得懂", "成员提问必有回应"],
    joinTip: "扫码后填写一句入群理由，管理员审核后拉群。",
  },
  {
    id: "yule-quan-qianxian",
    rank: 3,
    name: "娱乐圈前线情报局",
    category: "娱乐八卦",
    platform: "QQ群",
    members: 3980,
    activity: 90,
    rating: 4.8,
    score: 93,
    trend: "up",
    featured: true,
    tags: ["深度", "理性讨论", "资料全"],
    summary:
      "偏理性分析的讨论群，成员会主动核对时间线与公开资料，重事实、少情绪，适合不喜欢被带节奏的人。",
    highlights: ["讨论前先贴来源，减少道听途说", "每周出一份热点梳理长图", "老成员带新人，氛围稳定"],
    joinTip: "加群时备注「资料型」，通过率更高。",
  },
  {
    id: "zhui-ju-budangu",
    rank: 4,
    name: "追剧不孤单俱乐部",
    category: "影视追剧",
    platform: "微信群",
    members: 6240,
    activity: 89,
    rating: 4.7,
    score: 91,
    trend: "up",
    featured: true,
    tags: ["追剧", "推荐", "不剧透"],
    summary:
      "以剧集讨论为主，新剧开播会同步开「讨论帖」，严格分区剧透，适合边看边聊又怕被剧透的观众。",
    highlights: ["剧透内容单独分区，互不打扰", "每部新剧都有追剧日历", "片单接龙，选剧不再纠结"],
    joinTip: "入群先看置顶规则，选择自己想追的剧集分频道。",
  },
  {
    id: "resou-chigua-guanchashi",
    rank: 5,
    name: "热搜吃瓜观察室",
    category: "时事热点",
    platform: "QQ频道",
    members: 7340,
    activity: 88,
    rating: 4.7,
    score: 90,
    trend: "flat",
    featured: true,
    tags: ["热搜", "多角度", "有观点"],
    summary:
      "围绕当日热搜展开的观察频道，鼓励多角度讨论，管理员会为热议话题开专门房间，避免大群刷屏。",
    highlights: ["热搜话题自动分房间讨论", "每日舆情小结，脉络清晰", "反对人身攻击，尺度把控好"],
    joinTip: "频道可直接加入，发言前请先在迎新房间完成自我介绍。",
  },
  {
    id: "wanghong-dongtai-zhuizong",
    rank: 6,
    name: "网红动态追踪群",
    category: "网红热点",
    platform: "微信群",
    members: 4410,
    activity: 86,
    rating: 4.6,
    score: 87,
    trend: "down",
    tags: ["短视频", "直播", "更新勤"],
    summary:
      "聚焦短视频与直播圈的最新动态，适合关注创作者生态的用户，群里对热点事件更新频率很高。",
    highlights: ["直播热点实时播报", "创作者涨粉数据整理", "群内定期做话题投票"],
    joinTip: "入群前请把昵称改为「地区+昵称」，方便交流。",
  },
  {
    id: "shenye-bagua-chat",
    rank: 7,
    name: "深夜八卦聊天室",
    category: "娱乐八卦",
    platform: "QQ群",
    members: 2870,
    activity: 82,
    rating: 4.5,
    score: 84,
    trend: "flat",
    tags: ["闲聊", "轻松", "夜猫子"],
    summary:
      "主打轻松闲聊氛围，话题从娱乐延伸到生活日常，晚上活跃度最高，适合下班后找人说说话。",
    highlights: ["夜间时段最热闹", "禁吵架，管理员在线巡查", "每周一次线上语音茶话会"],
    joinTip: "本群偏闲聊，只想看资讯的瓜友建议看其他推荐。",
  },
  {
    id: "yingshi-zong-anli",
    rank: 8,
    name: "影视综安利大本营",
    category: "影视追剧",
    platform: "微信群",
    members: 3590,
    activity: 84,
    rating: 4.6,
    score: 83,
    trend: "up",
    featured: true,
    tags: ["安利", "片单", "点评"],
    summary:
      "以「安利」为核心，成员会认真写短评说明推荐理由，群内片单按题材分类，找剧效率很高。",
    highlights: ["安利必须写清推荐理由", "片单按题材归档", "每月评选一部「本月最佳」"],
    joinTip: "入群后欢迎先发一条自己的片单，方便大家认识你。",
  },
  {
    id: "shenghuo-qushi-fenxiang",
    rank: 9,
    name: "生活趣事分享会",
    category: "生活趣事",
    platform: "微信群",
    members: 5010,
    activity: 80,
    rating: 4.5,
    score: 80,
    trend: "flat",
    tags: ["生活", "治愈", "正能量"],
    summary:
      "分享生活中的小趣事与暖心瞬间，较少涉足娱乐热点，适合想放松心情、远离争吵的用户。",
    highlights: ["主打治愈与正向分享", "每日一个「今日份快乐」", "周末线上活动丰富"],
    joinTip: "欢迎带一张生活照入群破冰，注意保护个人隐私。",
  },
  {
    id: "shishi-redian-pingshuo",
    rank: 10,
    name: "时事热点评说角",
    category: "时事热点",
    platform: "QQ群",
    members: 3260,
    activity: 79,
    rating: 4.4,
    score: 78,
    trend: "down",
    tags: ["理性", "资料", "有深度"],
    summary:
      "社会热点方向的讨论群，强调就事论事，鼓励附上信息来源，整体氛围偏理性克制。",
    highlights: ["发言建议附来源链接", "定期整理争议话题多方观点", "不欢迎情绪化引战"],
    joinTip: "入群需同意「理性讨论公约」后由管理员通过。",
  },
  {
    id: "youxi-dianjing-chigua",
    rank: 11,
    name: "游戏电竞吃瓜台",
    category: "游戏电竞",
    platform: "QQ频道",
    members: 6120,
    activity: 85,
    rating: 4.6,
    score: 77,
    trend: "up",
    tags: ["电竞", "赛事", "弹幕氛围"],
    summary:
      "围绕电竞赛事与游戏圈动态的频道，赛事期间会开实时讨论房，节奏快、氛围热闹。",
    highlights: ["赛事期间实时讨论房", "战队动态与转会消息汇总", "比赛复盘帖子质量高"],
    joinTip: "开赛前加入，能第一时间参与讨论。",
  },
  {
    id: "kuaile-yuanquan-bujizhan",
    rank: 12,
    name: "快乐源泉补给站",
    category: "生活趣事",
    platform: "微信群",
    members: 4180,
    activity: 76,
    rating: 4.4,
    score: 74,
    trend: "flat",
    tags: ["搞笑", "表情包", "轻松"],
    summary:
      "主打搞笑内容与表情包分享，正文字数少、氛围欢乐，适合碎片时间刷一刷。",
    highlights: ["表情包资源丰富", "深夜「笑不活了」专题", "无广告，管理员清理及时"],
    joinTip: "群内表情包可自由取用，但请勿用于商业用途。",
  },
  {
    id: "laogua-fupan-danganguan",
    rank: 13,
    name: "老瓜复盘档案馆",
    category: "娱乐八卦",
    platform: "QQ群",
    members: 2140,
    activity: 68,
    rating: 4.3,
    score: 70,
    trend: "down",
    tags: ["复盘", "资料", "长文"],
    summary:
      "专门复盘往年旧事的资料型群组，成员会整理事件完整脉络，适合想补齐来龙去脉的深度用户。",
    highlights: ["旧事复盘资料齐全", "图文长帖归档有序", "更新慢但质量高"],
    joinTip: "低频更新群，追求即时资讯的瓜友请谨慎加入。",
  },
  {
    id: "mingxing-tongkuan-qingbaosuo",
    rank: 14,
    name: "明星同款情报所",
    category: "网红热点",
    platform: "微信群",
    members: 3820,
    activity: 74,
    rating: 4.3,
    score: 69,
    trend: "flat",
    tags: ["穿搭", "同款", "购物粉"],
    summary:
      "从明星与网红穿搭切入的情报群，会整理同款单品与搭配思路，偏生活消费向。",
    highlights: ["同款单品信息整理", "季节穿搭专题", "理性消费提醒，不盲目带货"],
    joinTip: "群内不接广告合作，请勿发布个人代购信息。",
  },
  {
    id: "zongyi-mingchangmian",
    rank: 15,
    name: "综艺名场面收藏馆",
    category: "影视追剧",
    platform: "QQ群",
    members: 2960,
    activity: 71,
    rating: 4.2,
    score: 66,
    trend: "down",
    tags: ["综艺", "名场面", "二创"],
    summary:
      "收集综艺名场面的二创与剪辑素材，群内有成员分享剪辑技巧，适合喜欢二次创作的用户。",
    highlights: ["名场面剪辑素材共享", "每周一次剪辑接龙", "标注素材来源，尊重版权"],
    joinTip: "发布他人作品请注明出处，尊重原创。",
  },
  {
    id: "niming-baoliao-shudong",
    rank: 16,
    name: "理性爆料树洞",
    category: "时事热点",
    platform: "QQ频道",
    members: 1780,
    activity: 62,
    rating: 4.1,
    score: 60,
    trend: "flat",
    tags: ["投稿", "审核严", "低噪"],
    summary:
      "接受匿名投稿但审核严格的频道，未核实内容一律标注「待证实」，整体节奏偏慢但可信度相对高。",
    highlights: ["所有投稿均标注可信度", "禁止发布他人隐私信息", "管理员会主动辟谣"],
    joinTip: "投稿请勿包含个人隐私，违规内容一律删除。",
  },
];